<section *ngIf="!isOpened">
  <div class="row justify-content-between row-buttons align-center mb-2">
    <div class="col-12 col-sm-12">
      <div class="container-style d-grid gap-2 d-flex justify-content-between">
        <app-custom-button [title]="'Regresar'" [icon]="'pi pi-arrow-left'" [link]="true" [label]="'Regresar'"
          [width]="'6rem'" [routerLink]="['/', url]" [severity]="null"></app-custom-button>
        <app-custom-button [title]="'Nuevo'" [label]="'Nuevo'" [severity]="'success'" [variant]="undefined"
          [icon]="'pi pi-plus'" [width]="'5.5rem'" (onClick)="createNewClient()"></app-custom-button>
      </div>
    </div>
  </div>
  <div class="row">
    <form class="needs-validation container-style" novalidate [formGroup]="formClient">
      <div class="ps-2 pe-2">
        <div class="row">
          <div class="col-md-12 col-12 d-flex justify-content-end align-items-center gap-1 mt-1">
            <app-custom-button [title]="'Eliminar Cliente'" [icon]="'pi pi-trash'" [severity]="'danger'"
              (onClick)="deleteClient()"></app-custom-button>
          </div>
          <hr class="my-1">
        </div>
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-12">
            <app-custom-audit-info [userNameCreate]="clientContract.userNameCreate"
              [createDate]="clientContract.createDate" [userNameUpdate]="clientContract.userNameUpdate"
              [updateDate]="clientContract.updateDate" [reserveSpace]="true"></app-custom-audit-info>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6 col-12">
            <div class="row">
              <div class="col-lg-3 col-md-3 col-sm-4 col-12">
                <app-custom-select formControlName="typeDocumentId" [labelText]="'Tipo Documento'"
                  [list]="listTypeDocument" [required]="true" [recovery]="true">
                </app-custom-select>
              </div>
              <div class="col-lg-2 col-md-2 col-sm-3 col-8">
                <app-custom-input-text formControlName="document" [labelText]="'Documento'" [required]="true"
                  [maxLength]="15" [recovery]="true" (onChangeTextOnBlur)="changeDocument()"></app-custom-input-text>
              </div>
              <div class="col-lg-1 col-md-1 col-sm-1 col-4">
                <app-custom-input-text formControlName="digitVerification" [labelText]="'DV'"></app-custom-input-text>
              </div>
              <div class="col-lg-2 col-md-2 col-sm-3 col-8">
                <app-custom-input-text formControlName="document2" [labelText]="'Documento 2'" [recovery]="true"
                  [maxLength]="15" (onChangeTextOnBlur)="changeDocument()"></app-custom-input-text>
              </div>
              <div class="col-lg-1 col-md-1 col-sm-1 col-4">
                <app-custom-input-text formControlName="digitVerification2" [labelText]="'DV2'"></app-custom-input-text>
              </div>
              <div class="col-lg-2 col-md-2 col-sm-3 col-6">
                <app-custom-select formControlName="typePersonId" [labelText]="'Tipo Persona'" [list]="listTypePerson"
                  [required]="true" (onChangeSelect)="changeTypePerson($event)">
                </app-custom-select>
              </div>
              <div class="col-lg-1 col-md-1 col-sm-3 col-6 d-flex align-items-end">
                <app-custom-button [title]="'Actualizar Documento'" [icon]="'pi pi-sync'"
                  [disabled]="disableUpdateDocument" (onClick)="openChangeDocumentModal()"></app-custom-button>
                <app-custom-modal #changeDocumentModal [label]="'Actualizar Documento'" [width]="'25rem'"
                  [header]="'Actualizar Documento'" [inputs$]="inputsForChangeDocumentModals$"
                  [children]="componentChangeDocumentModal" (params)="reloadClient($event.reload)" hidden>
                </app-custom-modal>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                <app-custom-input-text formControlName="names" [labelText]="'Nombres'" [maxLength]="75"
                  (onChangeTextOnBlur)="changeNames()"></app-custom-input-text>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                <app-custom-input-text formControlName="lastNames" [labelText]="'Apellidos'" [maxLength]="75"
                  (onChangeTextOnBlur)="changeNames()"></app-custom-input-text>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                <app-custom-input-text formControlName="businessName" [labelText]="'Razón Social'" [maxLength]="150"
                  [required]="true"></app-custom-input-text>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                <app-custom-input-text formControlName="businessName2" [maxLength]="150"
                  [labelText]="'Razón Social 2'"></app-custom-input-text>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                <app-custom-input-text formControlName="comercialName" [maxLength]="100"
                  [labelText]="'Nombre Comercial'"></app-custom-input-text>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                <app-custom-inputgroup [inputValue]="cityName" [labelText]="'Ciudad'"
                  [iconButton]="'pi pi-external-link'" [titleButton]="'Seleccionar Ciudad'" [required]="true"
                  (onClick)="openCitySelectionModal()"></app-custom-inputgroup>
                <app-custom-modal #selectCity [label]="'Seleccionar'" [header]="'Selección de Ciudades'"
                  [children]="componentCitySelection" [inputs$]="inputsForSelectCityModal$" [output$]="output$"
                  (selectedItems)="setCityDepartment($event)" hidden></app-custom-modal>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                <app-custom-input-text [value]="departmentName" [labelText]="'Departamento'"
                  [disabled]="true"></app-custom-input-text>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                <app-custom-input-text formControlName="address" [labelText]="'Dirección'" [maxLength]="70"
                  [required]="true"></app-custom-input-text>
              </div>
              <div class="checkbox-declarant mt-3">
                <app-custom-checkbox formControlName="swDeclarant" [labelText]="'Declarante'"></app-custom-checkbox>
              </div>
              <div class="checkbox-simpleTaxRegime mt-3">
                <app-custom-checkbox formControlName="swSimpleTaxRegime" [labelText]="'Reg.Simp.Tributación'"
                  (onChangeCheckBox)="changeIvaResponsible()"></app-custom-checkbox>
              </div>
              <div class="checkbox-ivaResponsible mt-3">
                <app-custom-checkbox formControlName="swIvaResponsible" [labelText]="'Responsable Iva'"
                  (onChangeCheckBox)="changeIvaResponsible()"></app-custom-checkbox>
              </div>
              <div *ngIf="visibleGreatContributor" class="checkbox-greatContributor mt-3">
                <app-custom-checkbox formControlName="swGreatContributor"
                  [labelText]="'Gran Contribuyente'"></app-custom-checkbox>
              </div>
              <div *ngIf="visibleGreatContributor" class="checkbox-ivaRetainer mt-3">
                <app-custom-checkbox formControlName="swIvaRetainer"
                  [labelText]="'Retenedor de IVA'"></app-custom-checkbox>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-12">
            <div class="row d-flex justify-content-end">
              <div class="row col-lg-10">
                <div class="col-lg-5 col-md-3 col-sm-5 col-4">
                  <app-custom-input-text formControlName="phone" [labelText]="'Teléfono'" [maxLength]="15"
                    [required]="true"></app-custom-input-text>
                </div>
                <div class="col-lg-5 col-md-3 col-sm-5 col-4">
                  <app-custom-input-text formControlName="alterPhone" [maxLength]="15"
                    [labelText]="'Teléfono Alterno'"></app-custom-input-text>
                </div>
                <div class="col-lg-2 col-md-1 col-sm-2 col-4">
                  <app-custom-input-text formControlName="postalCode" [labelText]="'Cod.Post'"
                    [maxLength]="10"></app-custom-input-text>
                </div>
                <div class="col-lg-6 col-md-5 col-sm-6 col-12">
                  <app-custom-input-text formControlName="email" [labelText]="'Correo'"
                    [maxLength]="250"></app-custom-input-text>
                </div>
                <div class="col-lg-6 col-md-5 col-sm-6 col-12">
                  <app-custom-input-text formControlName="taxEmail" [labelText]="'Correo Fiscal'" [maxLength]="250"
                    [required]="true"></app-custom-input-text>
                </div>
                <div class="col-lg-12 col-12" [hidden]="!visibleAdvancedOptions">
                  <fieldset class="border p-2 mt-2">
                    <div class="row">
                      <div class="col-lg-3 col-md-3 col-sm-3 col-6">
                        <app-custom-select formControlName="currencyId" [labelText]="'Moneda'" [list]="listCurrency"
                          [required]="true"></app-custom-select>
                      </div>
                      <div class="contacts">
                        <app-custom-input-decimal formControlName="ratePromptPayment"
                          [labelText]="'Tarifa P. Pago'"></app-custom-input-decimal>
                      </div>
                      <div class="contacts">
                        <app-custom-input-decimal formControlName="kgQuota"
                          [labelText]="'Cupo Kg'"></app-custom-input-decimal>
                      </div>
                      <div class="contacts">
                        <app-custom-input-text formControlName="ciiuCode" [labelText]="'CIIU Cód.'"
                          [maxLength]="4"></app-custom-input-text>
                      </div>
                      <div class="expiration-days mt-4">
                        <app-custom-checkbox formControlName="swExpirationDays"
                          [labelText]="'Días Venc.Part.'"></app-custom-checkbox>
                      </div>
                      <div [hidden]="!formClient.get('swExpirationDays')?.value" class="contacts">
                        <app-custom-input-number formControlName="expirationDays"
                          [labelText]="'Días Venc.'"></app-custom-input-number>
                      </div>
                    </div>
                  </fieldset>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-12" [hidden]="!visibleAdvancedOptions">
                  <fieldset class="border p-2 mt-2">
                    <div class="row">
                      <div class="col-lg-6 col-md-6 col-sm-6 col-6">
                        <app-custom-datepicker formControlName="stateChangeDate" [labelText]="'Fecha Cambio Est.'"
                          [required]="true"></app-custom-datepicker>
                      </div>
                      <div class="col-lg-6 col-md-6 col-sm-6 col-6">
                        <app-custom-select formControlName="clientStateId" [labelText]="'Cambiar Estado'"
                          [inputClass]="clientContract.clientStateId !== 1 ? 'text-danger' : ''"
                          [list]="listClientState" [required]="true" (onChangeSelect)="changeState($event)">
                        </app-custom-select>
                      </div>
                    </div>
                  </fieldset>
                </div>
                <div class="contacts d-flex align-items-end mb-2">
                  <app-custom-button [hidden]="!visibleAdvancedOptions" [title]="'Contactos'" [label]="'Contactos'"
                    [disabled]="disabledForm" (onClick)="openContactModal(true)"></app-custom-button>
                  <app-custom-modal #clientContactModal [label]="'Contactos'" [header]="'Contactos'" [width]="'75vw'"
                    [inputs$]="inputsForContactModals$" [children]="componentContactModal" hidden></app-custom-modal>
                </div>
                <div class="references d-flex align-items-end mb-2">
                  <app-custom-button [hidden]="!visibleAdvancedOptions" [title]="'Referencias'" [label]="'Referencias'"
                    [disabled]="disabledForm" [width]="'5.5rem'"
                    (onClick)="openContactModal(false)"></app-custom-button>
                  <app-custom-modal #clientReferenceModal [label]="'Referencias Comerciales'"
                    [header]="'Referencias Comerciales'" [width]="'75vw'" [inputs$]="inputsForContactModals$"
                    [children]="componentContactModal" hidden></app-custom-modal>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6 col-md-10 col-sm-10 col-12 mt-2">
            <app-custom-textarea formControlName="observation" [labelText]="'Observación'" [autoResize]="false"
              [maxLength]="500" [rows]="1"></app-custom-textarea>
          </div>
          <div class="col-lg-1 col-md-2 col-sm-2 col-12 d-flex align-items-end mt-2">
            <app-custom-button [title]="'Guardar'" [label]="'Guardar'" [variant]="undefined"
              (onClick)="send()"></app-custom-button>
          </div>
        </div>
      </div>
    </form>
  </div>
</section>
<!-- Mensaje de duplicidad ventanas abiertas -->
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1"> highlight_off </span>
  <h6>No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>